<template>
  <div class="page_reportManage">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="flex aic">
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="100px">
            <el-form-item label="申请人" size="small" v-if="activeName!='2'">
              <el-select v-model="listQuery.applyUserNameId" placeholder="" clearable size="small" style="width: 180px;" filterable @change="getList">
                <el-option v-for="(item,index) in customerList" :key="index" :label="item.Username" :value="item.Userid"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="项目名称" size="small" v-if="activeName!='2'">
              <el-select v-model="listQuery.projectName" placeholder="" value-key="Projectid" size="small" style="width: 180px;" clearable filterable>
                <el-option v-for="(item, index) in proNameList" :key="index" :label="item.StrprojectName" :value="item.StrprojectName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="项目名称" size="small" v-if="activeName=='2'">
              <el-select v-model="listQuery.project" placeholder="" value-key="Projectid" size="small" style="width: 180px;" clearable filterable>
                <el-option v-for="(item, index) in proNameList" :key="index" :label="item.StrprojectName" :value="item.StrprojectName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="归属月" size="small" v-if="activeName!='2'">
              <el-date-picker v-model="listQuery.attrMonth" value-format="yyyy-MM" type="month" size="small" placeholder="" style="width: 180px;"></el-date-picker>
            </el-form-item>
            <el-form-item label="交易时间" size="small" v-if="activeName!='2'">
              <el-date-picker v-model="tradingTimeRange" type="daterange" value-format="yyyy-MM-dd" size="small" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" style="width: 240px;" @change="searchHandle"></el-date-picker>
            </el-form-item>
            <el-form-item label="服务部门" size="small" v-if="activeName=='2'">
              <el-input v-model="listQuery.depName" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
            <el-form-item label="收入编号" size="small" v-if="activeName=='2'">
              <el-input v-model="listQuery.advanceNum" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
          </el-form>
          <div class="screenInput">
            <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
              <i class="i_txt" @click="dropDownScreen">{{ showDropScreen == 1 ? '收起' : '更多' }}<i class="el-icon-caret-bottom"></i></i>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="top-right">
        <el-button v-if="showDropScreen == -1" v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <!-- 筛选下拉框 -->
    <div class="r_dropDownScreen" v-show="showDropScreen == 1">
      <div class="pro_down_box" style="padding-left: 28px;">
        <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="100px">
          <div v-if="activeName!='2'">
            <el-form-item label="费用名称" size="small">
              <el-select v-model="listQuery.advanceType" placeholder="" clearable filterable style="width:180px">
                <el-option value="一般暂支"></el-option>
                <el-option value="西南暂支"></el-option>
                <el-option value="工伤/工资暂支"></el-option>
                <el-option value="供应商返费暂支"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="申请公司" size="small">
              <el-input v-model="listQuery.applyComp" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
            <el-form-item label="合伙人" size="small">
              <el-select v-model="listQuery.Partner" placeholder="" clearable size="small" style="width: 180px;" filterable @change="getList">
                <el-option v-for="(item,index) in customerList" :key="index" :label="item.Username" :value="item.Username"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="收入类型" size="small">
              <el-select v-model="listQuery.advanceType" placeholder="" size="small" style="width: 180px;" clearable filterable>
                <el-option value="发薪"></el-option>
                <el-option value="日志报销"></el-option>
                <el-option value="暂支"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="我方户名" size="small">
              <el-input v-model="listQuery.accountName" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
            <el-form-item label="我方账号" size="small">
              <el-input v-model="listQuery.accountNo" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
            <el-form-item label="对方户名" size="small">
              <el-input v-model="listQuery.oppositeName" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
            <el-form-item label="对方账号" size="small">
              <el-input v-model="listQuery.oppositeAccount" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
            <el-form-item label="到款开始时间" size="small">
              <el-date-picker v-model="listQuery.receivedTimeStart" type="date" value-format="yyyy-MM-dd" size="small" style="width: 180px;">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="到款结束时间" size="small">
              <el-date-picker v-model="listQuery.receivedTimeEnd" type="date" value-format="yyyy-MM-dd" size="small" style="width: 180px;">
              </el-date-picker>
            </el-form-item>
          </div>
          <div v-if="activeName=='2'">
            <el-form-item label="修改人" size="small">
              <el-select v-model="listQuery.userName" placeholder="" clearable size="small" style="width: 180px;" filterable @change="getList">
                <el-option v-for="(item,index) in customerList" :key="index" :label="item.Username" :value="item.Username"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="修改开始时间" size="small">
              <el-date-picker v-model="listQuery.actionTimeStart" type="date" value-format="yyyy-MM-dd" size="small" style="width: 180px;">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="修改结束时间" size="small">
              <el-date-picker v-model="listQuery.actionTimeEnd" type="date" value-format="yyyy-MM-dd" size="small" style="width: 180px;">
              </el-date-picker>
            </el-form-item>
          </div>
          <!-- <div>
            <el-form-item label="客服" size="small">
              <el-input v-model="listQuery.name" size="small" clearable></el-input>
            </el-form-item>
          </div> -->
        </el-form>
      </div>
      <div class="drop-footer">
        <el-button size="small" plain @click="resetHandle()">清空</el-button>
        <el-button size="small" type="info" plain @click="showDropScreen = -1">关闭</el-button>
        <el-button v-preventReClick size="small" type="success" @click="searchHandle()">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>收支</el-breadcrumb-item>
          <el-breadcrumb-item>明细</el-breadcrumb-item>
          <el-breadcrumb-item>管理报表收入</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="ftabs">
        <el-tabs v-model="activeName" type="card" @tab-click="changeTab">
          <el-tab-pane label="利润表收入" name="0"></el-tab-pane>
          <el-tab-pane label="系统原始数据" name="1"></el-tab-pane>
          <el-tab-pane label="加工记录" name="2"></el-tab-pane>
        </el-tabs>
        <div class="ftabBtn flex" v-if="activeName!='2'">
          <el-button type="success" size="small" @click="handelSign">资金收入登记</el-button>
          <el-button type="warning" size="small" @click="importList">资金收入批量导入</el-button>
          <el-button type="primary" size="small" @click="expList" :loading="isexping">导出</el-button>
        </div>
        <el-table :data="tableData" border class="doc_table" v-loading="loading" style="width:100%">
          <template v-if="activeName!='2'">
            <el-table-column prop="advanceNum" label="收入编号" min-width="160" :show-overflow-tooltip="true" align="center" fixed="left">
            </el-table-column>
            <!-- <el-table-column label="流程编号" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column> -->
            <el-table-column prop="project" label="项目/部门" min-width="120" :show-overflow-tooltip="true" align="center">
              <template slot-scope="{row}">{{ row.project ? row.project : row.depName }}</template>
            </el-table-column>
            <el-table-column prop="amountReceived" label="到款金额" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="attrMonth" label="归属月" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="accountName" label="我方户名" min-width="160" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="accountNo" label="我方账号" min-width="140" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="oppositeName" label="对方户名" min-width="160" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="oppositeAccount" label="对方账号" min-width="140" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <!-- <el-table-column prop="amountReceived" label="到款编号" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column> -->
            <el-table-column prop="claimNum" label="认领编号" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="transactionSerialNumber" label="银行流水号" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="receivedTime" label="到款时间" min-width="160" :show-overflow-tooltip="true" align="center">
              <template slot-scope="{row}">{{ row.receivedTime ? row.receivedTime.replace('T',' ') : '' }}</template>
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间" min-width="160" :show-overflow-tooltip="true" align="center">
              <template slot-scope="{row}">{{ row.createTime ? row.createTime.replace('T',' ') : '' }}</template>
            </el-table-column>
            <el-table-column prop="createUserName" label="创建人" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="partner2" label="合伙人" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="strpartner" label="业务员" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="remark" label="备注" min-width="150" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="abstract" label="摘要" min-width="150" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="createMode" label="创建方式" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column label="操作" align="center" width="150px" fixed="right">
              <template slot-scope={row}>
                <div class="injuryTabBtn">
                  <el-button type="text" @click="edit(row)">编辑</el-button>
                  <el-button type="text" @click="splitData(row)">拆分</el-button>
                  <el-button type="text">删除</el-button>
                </div>
              </template>
            </el-table-column>
          </template>
          <template v-else>
            <el-table-column label="收入编号" prop="advanceNum" min-width="140" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column label="服务项目" prop="serviceProject" min-width="140" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column label="服务公司部门" prop="servicDep" min-width="140" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column label="修改内容" prop="content" min-width="200" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column label="修改时间" prop="actionTime" min-width="140" :show-overflow-tooltip="true" align="center">
              <template slot-scope="{row}">{{ row.actionTime.replace('T',' ') }}</template>
            </el-table-column>
            <el-table-column label="修改人" prop="userName" min-width="140" :show-overflow-tooltip="true" align="center">
            </el-table-column>

            <el-table-column label="修改备注" prop="remark" min-width="140" :show-overflow-tooltip="true" align="center">
            </el-table-column>
          </template>
        </el-table>
        <div class="block">
          <el-pagination v-if="totalCount>0" @current-change="currentChange" :current-page.sync="listQuery.PageModel.Page" :page-size="Number(listQuery.PageModel.Rows)" @size-change="handleSizeChange" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

    <el-dialog :title="type=='add' ? '收入登记' : '编辑'" :visible.sync="showSign" width="650px">
      <el-form :model="signForm" :inline="true" ref="signForm" :rules="signRules" label-width="100px">
        <el-form-item label="归属项目">
          <el-select v-model="projectName" placeholder="" value-key="Projectid" size="small" style="width: 180px;" clearable filterable @change="changePro">
            <el-option v-for="(item, index) in proNameList" :key="index" :label="item.StrprojectName" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="归属部门">
          <el-cascader v-model="depName" size="small" :props="props" clearable filterable :options="departList" placeholder="" @change="departChange" style="width:180px"></el-cascader>
        </el-form-item>
        <el-form-item label="收入金额" prop="amountReceived">
          <el-input v-model="signForm.amountReceived" placeholder="" type="number" size="small" style="width: 180px;"></el-input>
        </el-form-item>
        <el-form-item label="归属月" prop="attrMonth">
          <el-date-picker v-model="signForm.attrMonth" type="month" value-format="yyyy-MM" size="small" style="width: 180px;"></el-date-picker>
        </el-form-item>
        <el-form-item label="发生日期">
          <el-date-picker v-model="signForm.receivedTime" type="date" value-format="yyyy-MM-dd" size="small" style="width: 180px;"></el-date-picker>
        </el-form-item>
        <el-form-item label="对方名称" prop="costName">
          <el-input v-model="signForm.costName" placeholder="" size="small" style="width: 180px;"></el-input>
        </el-form-item>
        <el-form-item label="对方账号" prop="costName">
          <el-input v-model="signForm.costName" placeholder="" size="small" style="width: 180px;"></el-input>
        </el-form-item>
        <el-form-item label="对方开户行" prop="costName">
          <el-input v-model="signForm.costName" placeholder="" size="small" style="width: 180px;"></el-input>
        </el-form-item>
        <el-form-item label="银行流水号">
          <el-input v-model="signForm.transactionSerialNumber" placeholder="" size="small" style="width: 180px;"></el-input>
        </el-form-item>
        <div>
          <el-form-item label="备注">
            <el-input v-model="signForm.remark" type="textarea" :autosize="{ minRows: 3}" size="small" clearable style="width: 300px;"></el-input>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showSign = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmSign" :loading="isBtnLoading">提 交</el-button>
      </span>
    </el-dialog>

    <el-dialog title="收入拆分" :visible.sync="showSplit" width="1050px">
      <div v-if="showSplit">
        <div class="title_line flex">
          <div class="title_item">金额</div>
          <div class="title_item">服务部门</div>
          <div class="title_item">服务项目</div>
          <div class="title_item">发生日期</div>
          <div class="title_item">归属月</div>
          <div class="title_item">备注</div>
        </div>
        <div class="total_line flex">
          <div class="total_title">总收入金额：</div>
          <div class="title_item">{{ info.amountReceived }}</div>
          <div class="title_item">{{ info.depName }}</div>
          <div class="title_item">{{ info.project }}</div>
          <div class="title_item">{{ info.receivedTime ? info.receivedTime.split('T')[0] : '' }}</div>
          <div class="title_item">{{ info.attrMonth }}</div>
          <div class="title_item">{{ info.remark }}</div>
        </div>
        <div class="total_line remove_box flex">
          <div class="total_title">拆出：</div>
          <div>
            <div class="remove_item flex" v-for="(item,index) in splitForm.List" :key="index">
              <el-input v-model="item.amountReceived" placeholder="" type="number" size="small" style="width: 100px;" @blur="calSum"></el-input>

              <el-cascader v-model="item.depName" size="small" :props="props" clearable filterable :options="departList" placeholder="" @change="(val)=>{departChange2(val,item)}" style="width:100px;margin-left: 10px;"></el-cascader>

              <el-select v-model="item.project" placeholder="" value-key="Projectid" size="small" style="width: 100px;margin-left: 12px;" clearable filterable @change="(val)=>{changePro2(val,item)}">
                <el-option v-for="(item, index) in proNameList" :key="index" :label="item.StrprojectName" :value="item"></el-option>
              </el-select>

              <el-date-picker v-model="item.receivedTime" type="date" value-format="yyyy-MM-dd" size="small" style="width: 100px;margin-left: 12px;"></el-date-picker>

              <el-date-picker v-model="item.attrMonth" type="month" value-format="yyyy-MM" size="small" style="width: 100px;margin-left: 12px;"></el-date-picker>

              <el-input v-model="item.remark" placeholder="" size="small" style="width: 100px;margin-left: 12px;"></el-input>
            </div>
          </div>
        </div>

        <div class="total_line flex">
          <div class="total_title">剩余金额：</div>
          <div class="title_item"> {{ remainingAmount }} </div>
        </div>

        <div class="total_line flex">
          <div class="blueName cp" @click="addSplitItem">+继续拆分</div>
          <div class="blueName cp" @click="importSplit" style="margin-left: 10px">导入拆分</div>
          <div class="blueName cp" @click="downTemp" style="margin-left: 10px">下载模板</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showSplit = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmSplit" :loading="isBtnLoading">提 交</el-button>
      </span>
    </el-dialog>

    <el-dialog title="导入拆分" :visible.sync="showImport" width="500px">
      <el-form :model="signForm" ref="signForm" :rules="signRules" label-width="100px">
        <el-form-item label="导入拆分" prop="imp">
          <el-upload class="upload-demo" ref="file" action="#" :on-change="success_handle" :auto-upload="false" :limit="1" :on-remove="handleFileRemove" :on-exceed="handleExceed" :file-list="fileList">
            <el-button size="small" type="primary">导入</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="导入模板">
          <div class="blueName cp" @click="downTemp">下载模板</div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showImport = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmImport" :loading="isBtnLoading">提 交</el-button>
      </span>
    </el-dialog>

    <el-dialog title="资金收入批量导入" :visible.sync="showImportList" width="500px">
      <el-form :model="signForm" ref="signForm" :rules="signRules" label-width="140px">
        <el-form-item label="资金收入批量导入" prop="imp">
          <el-upload class="upload-demo" ref="file" action="#" :on-change="success_handle2" :auto-upload="false" :limit="1" :on-remove="handleFileRemove2" :on-exceed="handleExceed2" :file-list="fileList">
            <el-button size="small" type="primary">导入</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="导入模板">
          <div class="blueName cp" @click="downListTemp">下载模板</div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showImportList = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmImportList" :loading="isBtnLoading">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import * as math from 'mathjs'
  import xz from "../../common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        listQuery: {
          PageModel: {
            Rows: 10,
            Page: 1,
            OrderInput: [{
              property: 'attrMonth',
              order: 1
            }, {
              property: 'updataTime',
              order: 1
            }]
          },
          busiType: 2, //1为原始数据2为利润
          advanceNum: '', //收入编号
          project: '', //服务项目
          depName: '', //部门
          attrMonth: '', //归属月份
          tradingTimeStart: '', //交易时间起
          tradingTimeEnd: '', //交易时间止
          amountReceived: null, //到款金额
          claimNum: '', //认领编号
          transactionSerialNumber: '', //交易序列号
          amountReceivedStart: '', //
          amountReceivedEnd: '', //
          receivedTimeStart: '', //到款时间
          receivedTimeEnd: '', //
          createTimeStart: '', //创建时间
          createTimeEnd: '', //
          createMode: '', //创建方式
          partner2: '', //合伙人
          strpartner: '', //业务团长
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype,
        },
        signForm: {},
        tradingTimeRange: [], //交易时间范围
        showDropScreen: -1,
        activeName: '0',
        showSign: false,
        tableData: [],
        roletype: localStorage.loginRoletype,
        totalCount: 0,
        loading: false,
        proNameList: [], //项目列表
        departList: [], //部门列表
        customerList: [],
        depName: '',
        isBtnLoading: false,
        type: '',
        signForm: {
          Id: '',
          writtenNum: '', //OA编号
          projectId: '', //项目ID
          project: '', //服务项目
          depName: '', //服务部门
          claimNum: "", //认领编号
          receivedTime: "", //到款时间
          transactionSerialNumber: '', //交易序列号
          attrMonth: '', //归属月份
          amountReceived: '', //到款金额
          remark: '', //备注
          advanceNum: '', //收入编号
          costName: ''
        },
        info: {},
        projectName: '',
        applyUserName: '',
        signRules: {
          amountReceived: {
            required: true,
            message: '请输入金额',
            trigger: 'blur'
          },
          attrMonth: {
            required: true,
            message: '请选择归属月',
            trigger: 'change'
          },
          imp: {
            required: true,
            message: '请导入',
            trigger: 'change'
          },
        },
        props: {
          label: "strorganname",
          value: "strorganname",
          children: "children",
          checkStrictly: true,
        },
        showSplit: false, //拆分弹窗
        remainingAmount: 0, //剩余金额
        splitForm: {
          Id: '',
          List: [{
            amountReceived: '', //金额
            project: '', //服务项目
            depName: '', //服务部门
            receivedTime: '', //发生时间
            attrMonth: '', //归属月份
            projectId: '', //
            advanceType: '', //暂支分类
            remark: '', //备注
          }],
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype,
        },
        showImport: false,
        fileUrl: '',
        fileList: [],
        showImportList: false,
        fileUrl2: '',
        fileList2: [],
        isexping: false,
      }
    },
    created() {
      this.getList();
      this.getProList();
      this.getDepartList();
      this.getMemberList();
    },
    methods: {
      checkPermission,
      //获取项目
      getProList() {
        let data = {
          projectName: "", // 项目名称
          projectid: "", // 项目id
          custname: "", //客户名称
          strAchieveowner: "", // 业绩归属人
          strservuserid: "", // 客服
          strBusiStat: "", //项目状态
          strpartner2: "", //合伙人
          perpage: 100000000,
          currpage: 1,
          strorgancode: "",
          roletype: this.roletype,
        }
        xz.getProjectLists(data).then((res) => {
          if (res.status == "ok") {
            this.proNameList = res.msg;
          } else {
            this.proNameList = [];
          }
        });
      },
      // 获取部门列表
      getDepartList() {
        xz.getOrganstrsreach("", {
          strIsDisable: "1",
        }).then((res) => {
          // console.log('部门', res)
          if (res.status == "ok") {
            if (res.msg && res.msg.parent) {
              this.departList = res.msg.parent[0].children;
            } else {
              this.departList = [];
            }
          }
        });
      },
      // 获取人员列表
      getMemberList(type) {
        let data = {
          currpage: 1,
          perpage: 10000000,
          keyword: "",
          strWorkState: "",
          strstation: "",
          strorgancode: "",
        }
        xz.getauthUserInfoByorgancode(data).then((res) => {
          if (res.status == "ok") {
            this.customerList = res.msg;
          } else {
            this.customerList = [];
          }
        });
      },
      currentChange(val) {
        this.listQuery.PageModel.Page = Number(val);
        this.getList();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.PageModel.Page = 1;
        this.listQuery.PageModel.Rows = val;
        this.getList();
      },
      searchHandle() {
        this.listQuery.PageModel.Page = 1;
        this.listQuery.tradingTimeStart = this.tradingTimeRange && this.tradingTimeRange.length > 0 ? this.tradingTimeRange[0] : '';
        this.listQuery.tradingTimeEnd = this.tradingTimeRange && this.tradingTimeRange.length > 1 ? this.tradingTimeRange[1] : '';
        this.getList();
      },
      getList() {
        this.loading = true;
        let pagename = this.activeName == '2' ? 'GetAdvFinanExpendLogList' : 'GetAdvanceFinanIncomesList';
        xz.AdvanceFun(this.listQuery, pagename).then(res => {
          if (res.status == 'ok') {
            this.tableData = res.data.data;
            this.totalCount = res.data.pageModel.totalCount;
            this.loading = false;
          } else {
            this.tableData = [];
            this.totalCount = 0;
            this.loading = false;
          }
        })
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      changeTab() {
        if (this.activeName == '0') {
          this.listQuery = {
            PageModel: {
              Rows: 10,
              Page: 1,
              OrderInput: [{
                property: 'attrMonth',
                order: 1
              }, {
                property: 'updataTime',
                order: 1
              }]
            },
            busiType: 2, //1为原始数据2为利润
            advanceNum: '', //收入编号
            project: '', //服务项目
            depName: '', //部门
            attrMonth: '', //归属月份
            amountReceived: null, //到款金额
            claimNum: '', //认领编号
            transactionSerialNumber: '', //交易序列号
            amountReceivedStart: '', //
            amountReceivedEnd: '', //
            receivedTimeStart: '', //到款时间
            receivedTimeEnd: '', //
            createTimeStart: '', //创建时间
            createTimeEnd: '', //
            createMode: '', //创建方式
            partner2: '', //合伙人
            strpartner: '', //业务团长
            userId: Cookies.get("userid-b"),
            roleType: localStorage.loginRoletype,
          }
        } else if (this.activeName == '1') {
          this.listQuery = {
            PageModel: {
              Rows: 10,
              Page: 1,
              OrderInput: [{
                property: 'attrMonth',
                order: 1
              }, {
                property: 'updataTime',
                order: 1
              }]
            },
            busiType: 1, //1为原始数据2为利润
            advanceNum: '', //收入编号
            project: '', //服务项目
            depName: '', //部门
            attrMonth: '', //归属月份
            amountReceived: null, //到款金额
            claimNum: '', //认领编号
            transactionSerialNumber: '', //交易序列号
            amountReceivedStart: '', //
            amountReceivedEnd: '', //
            receivedTimeStart: '', //到款时间
            receivedTimeEnd: '', //
            createTimeStart: '', //创建时间
            createTimeEnd: '', //
            createMode: '', //创建方式
            partner2: '', //合伙人
            strpartner: '', //业务团长
            userId: Cookies.get("userid-b"),
            roleType: localStorage.loginRoletype,
          }
        } else if (this.activeName == '2') {
          this.listQuery = {
            PageModel: {
              Rows: 10,
              Page: 1,
              OrderInput: [{
                property: 'actionTime',
                order: 1
              }]
            },
            busiType: 2, //支出1 收入2
            advanceNum: '',
            depName: '',
            userName: '',
            project: '',
            actionTimeStart: "",
            actionTimeEnd: "",
            userId: Cookies.get("userid-b"),
            roleType: localStorage.loginRoletype,
          }
        }
        this.getList();
      },
      //登记
      handelSign() {
        this.type = 'add';
        this.showSign = true;
      },
      //编辑
      edit(row) {
        this.type = 'edit';
        this.info = row;
        this.signForm = row;
        this.projectName = {
          Projectid: row.projectId,
          StrprojectName: row.project
        }
        this.applyUserName = {
          Userid: row.applyUserNameId
        }
        this.showSign = true;
      },
      departChange(val) {
        this.signForm.depName = val[val.length - 1];
      },
      changePro(val) {
        if (val != undefined && val) {
          this.signForm.projectId = val.Projectid;
          this.signForm.project = val.StrprojectName;
        }
      },
      changeUser(val) {
        this.signForm.applyUserNameId = val.Userid;
        this.signForm.applyUserName = val.Username;
      },
      //确认登记
      confirmSign() {
        this.isBtnLoading = true;
        xz.AdvanceFun(this.signForm, 'AddUpdataFinanIncome').then(res => {
          if (res.status == 'ok') {
            this.$message.success('保存成功');
            this.isBtnLoading = false;
            this.showSign = false;
            this.getList();
          } else {
            this.$message.error(res.msg);
            this.isBtnLoading = false;
            // this.showSign = false;
            // this.getList();
          }
        })
      },
      //拆分
      splitData(row) {
        this.info = row;
        this.remainingAmount = row.amountReceived;
        this.splitForm = {
          Id: row.id,
          List: [{
            amountReceived: '', //金额
            project: '', //服务项目
            depName: '', //服务部门
            receivedTime: '', //发生时间
            attrMonth: '', //归属月份
            projectId: '', //
            advanceType: '', //暂支分类
            remark: '', //备注
          }],
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype,
        }
        this.showSplit = true;
      },
      departChange2(val, item) {
        this.$set(item, 'depName', val[val.length - 1])
      },
      changePro2(val, item) {
        this.$set(item, 'project', val.StrprojectName)
        this.$set(item, 'projectId', val.Projectid)
      },
      changeUser2(val, item) {
        this.$set(item, 'applyUserNameId', val.Userid)
        this.$set(item, 'applyUserName', val.Username)
      },
      addSplitItem() {
        let data = {
          amountReceived: '', //金额
          project: '', //服务项目
          depName: '', //服务部门
          actionTime: '', //发生时间
          attrMonth: '', //归属月份
          serviceCompany: '', //服务公司
          costName: '', //费用名称
          projectId: '', //
          advanceType: '', //暂支分类
          remark: '', //备注
        }
        this.splitForm.List.push(data)
      },
      confirmSplit() {
        this.isBtnLoading = true;
        xz.AdvanceFun(this.splitForm, 'SplitFinanIncome').then(res => {
          if (res.status == 'ok') {
            this.$message.success('拆分成功');
            this.isBtnLoading = false;
            this.showSplit = false;
            this.getList();
          } else {
            this.$message.error(res.msg);
            this.isBtnLoading = false;
          }
        })
      },
      calSum() {
        let sum = 0;
        this.splitForm.List.forEach((element) => {
          sum = math.format(
            math.add(
              math.bignumber(sum), math.bignumber(Number(element.amountReceived))
            )
          )
          this.remainingAmount = this.info.amountReceived - sum;
          if (this.remainingAmount < 0) {
            this.$message.warning('拆分不能超出总金额')
          }
        });
      },
      downTemp() {
        let path = this.$store.state.EMP.tablePath + 'excel/9c895257-5e33-4888-9bd8-adb6df000386/E20241017101100272.xlsx';
        const aTag = document.createElement('a')
        aTag.href = path;
        aTag.download = "导入拆分模版.xlsx";
        aTag.click();
      },
      importSplit() {
        this.fileList = [];
        this.fileUrl = '';
        this.showImport = true;
      },
      handleExceed() {
        this.$message.warning(`只能导入 1 个文件`);
      },
      // 删除
      handleFileRemove() {
        this.fileUrl = '';
      },
      // 上传
      success_handle(file) {
        const formData = new FormData();
        formData.append("pagename", "empexcel");
        formData.append("action", "save");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("excel", file.raw, file.name);
        console.log("formData", formData, file);
        xz.uploadCert(formData).then((res) => {
          if (res) {
            this.fileUrl = res;
          } else {
            this.fileUrl = ''
          }
        });
      },
      //导入拆分
      confirmImport() {
        if (this.fileUrl) {
          let data = {
            id: this.info.id,
            fileUrl: this.fileUrl,
            userId: Cookies.get("userid-b"),
            roleType: localStorage.loginRoletype
          }
          this.isBtnLoading = true;
          xz.AdvanceFun(data, 'ImportSplitIncomeExpenses1').then(res => {
            if (res.status == 'ok') {
              this.$message.success('导入成功！');
              this.getList();
              this.isBtnLoading = false;
              this.showImport = false;
              this.showSplit = false;
            } else {
              this.$message.error(res.msg);
              this.getList();
              this.isBtnLoading = false;
              this.showImport = false;
              this.showSplit = false;
            }
          })
        }
      },
      downListTemp() {
        let path = this.$store.state.EMP.tablePath + 'excel/9c895257-5e33-4888-9bd8-adb6df000386/E20241017101018799.xlsx';
        const aTag = document.createElement('a')
        aTag.href = path;
        aTag.download = "资金收入批量导入模板.xlsx";
        aTag.click();
      },
      importList() {
        this.fileList2 = [];
        this.fileUrl2 = '';
        this.showImportList = true;
      },
      handleExceed2() {
        this.$message.warning(`只能导入 1 个文件`);
      },
      // 删除
      handleFileRemove2() {
        this.fileUrl2 = '';
      },
      // 上传
      success_handle2(file) {
        const formData = new FormData();
        formData.append("pagename", "empexcel");
        formData.append("action", "save");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("excel", file.raw, file.name);
        console.log("formData", formData, file);
        xz.uploadCert(formData).then((res) => {
          if (res) {
            this.fileUrl2 = res;
          } else {
            this.fileUrl2 = ''
          }
        });
      },
      confirmImportList() {
        if (this.fileUrl2) {
          let data = {
            fileUrl: this.fileUrl2,
            userId: Cookies.get("userid-b"),
            roleType: localStorage.loginRoletype
          }
          this.isBtnLoading = true;
          xz.AdvanceFun(data, 'ImportAdvanceFinanInComeExpend').then(res => {
            if (res.status == 'ok') {
              this.$message.success('导入成功！');
              this.getList();
              this.isBtnLoading = false;
              this.showImportList = false;
            } else {
              this.$message.error(res.msg);
              this.getList();
              this.isBtnLoading = false;
            }
          })
        }
      },
      expList() {
        let d = JSON.parse(JSON.stringify(this.listQuery));
        this.isexping = true;
        xz.ExportAdvanceList(d, 'ExportAdvanceFinanIncomesList').then(res => {
          try {
            var data = new Blob([res], {
              type: "application/vnd.ms-excel;charset=utf-8"
            });
            var downloadUrl = window.URL.createObjectURL(data);
            var anchor = document.createElement("a");
            anchor.href = downloadUrl;
            anchor.download = "管理报表收入列表.xlsx";
            anchor.click();
            window.URL.revokeObjectURL(data);
            this.isexping = false;
          } catch (e) {
            this.isexping = false;
            this.$message.error('导出异常')
          }
        })
      },
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 10px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 5px;
    margin-right: 0;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  .title_line {
    margin-left: 90px;
  }

  .title_item {
    min-width: 100px;
    font-size: 13px;
    text-align: center;
    margin: 0 6px;
  }

  .total_line {
    margin-top: 20px;
  }

  .total_title {
    font-weight: bold;
    width: 90px;
  }

  .remove_box {
    flex-wrap: wrap;
  }

  .remove_item {
    margin-bottom: 15px;
  }
</style>
<style>
  .page_reportManage .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_reportManage .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_reportManage .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_reportManage .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_reportManage .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_reportManage .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_reportManage .checkedgroup .el-checkbox {
    margin-right: 10px;
  }

  .page_reportManage .el-checkbox__label {
    padding-left: 3px;
  }

  .page_reportManage .checkedgroup2 .el-checkbox {
    margin-bottom: 5px;
  }
</style>